/* eslint-disable react/no-unknown-property */
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Reusable Components
import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import NotableInfo from "reusables/TextFormats/NotableInfo";
import UnNumberedList from "reusables/TextFormats/UnNumberedList";
import Email from "reusables/Contact/Email";

// Images

function Privacy_Section1() {
  const lineSpacing_lg = <MKBox mb={12} />;
  const lineSpacing_sm = <MKBox mb={2} />;

  return (
    <Container>
      <Grid
        container
        alignItems="center"
        // bgcolor={"red"}
        width={"100%"}
      >
        <Grid item xs={12}>
          <SubTitleContents
            title="Background"
            contents={
              <>
                This policy sets out how we collect, process and hold your personal data if you
                visit our website or provide personal data to us. This policy affects your legal
                rights and obligations so please read it carefully. If you have any questions,
                please contact us at{" "}
                <MKTypography component="span" color="info" fontWeight="bold">
                  <Email
                    email="info@spechs.ie"
                    subject="Inquiry"
                    body="Hello, I have a question about your services."
                  >
                    info@spechs.ie
                  </Email>{" "}
                </MKTypography>
                .{lineSpacing_sm}
                Spechs Property Services is committed to being transparent about how it handles
                personal information, particularly when it comes to protecting the privacy and
                security of your personal information and to meeting our data protection obligations
                under the General Data Protection Regulation (GDPR). The purpose of this privacy
                notice is to make you aware of how and why we will collect and use your personal
                information. This privacy notice applies to all future, current and former clients.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Data protection officer"
            contents={
              <>
                Spechs Property Services has appointed a data protection officer to oversee
                compliance with this privacy notice. If you have any questions about this privacy
                notice or about how we handle your personal information, please contact our:
                <MKBox mb={2} />
                <UnNumberedList
                  items={[
                    <>
                      <MKTypography component="span" color="text">
                        Office:{" "}
                      </MKTypography>
                      <MKTypography component="span">+353 21 206 3133</MKTypography>
                    </>,
                    <>
                      <MKTypography component="span" color="text">
                        Email:{" "}
                      </MKTypography>
                      <MKTypography component="span" fontWeight="bold">
                        <Email
                          email="info@spechs.ie"
                          subject="Inquiry"
                          body="Hello, I have a question about your services."
                        >
                          info@spechs.ie
                        </Email>{" "}
                      </MKTypography>
                    </>,
                  ]}
                />
                {/* <MKBox display="flex" flexDirection="column">
                  <MKBox display="flex" flexDirection="row" alignItems="center">
                    <MKBox display="flex">
                      <Icon fontSize="small">check_small</Icon>
                    </MKBox>
                    <MKBox display="flex">
                      <MKTypography variant="body1" color="text" pl={2}>
                        Office: +353 21 206 3133
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                  <MKBox display="flex" flexDirection="row" alignItems="center">
                    <MKBox display="flex">
                      <Icon fontSize="small">check_small</Icon>
                    </MKBox>
                    <MKBox display="flex">
                      <MKTypography variant="body1" color="text" pl={2}>
                        Email:{" "}
                        <MKTypography component="span" color="text" fontWeight="bold">
                          info@spechs.ie
                        </MKTypography>
                      </MKTypography>
                    </MKBox>
                  </MKBox>
                </MKBox> */}
                {lineSpacing_sm}
                You have the right to make a complaint at any time to the Information Commissioner’s
                Office (ICO). We would, however, appreciate the chance to resolve your concerns
                before you approach the ICO, so please contact us in the first instance.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Data protection principles"
            contents={
              <>
                Under the GDPR, there are six data protection principles that the Company must
                comply with. These provide that the personal information we hold about you must be:
                {lineSpacing_sm}
                <UnNumberedList
                  items={[
                    "Processed lawfully, fairly and in a transparent manner.",
                    "Collected only for legitimate purposes that have been clearly explained to you and not further processed in a way that is incompatible with those purposes.",
                    "Adequate, relevant and limited to what is necessary, in relation to those purposes.",
                    "Accurate and, where necessary, kept up to date.",
                    "Kept in a form that permits your identification for no longer than is necessary for those purposes.",
                    "Processed in a way that ensures appropriate security of the data.",
                  ]}
                />
                {lineSpacing_sm}
                Spechs Property Services is responsible for and must be able to demonstrate
                compliance with, these principles.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Personal data we collect"
            contents={
              <>
                Personal information is any information about an individual from which that person
                can be directly or indirectly identified. We collect, process, store and use
                personal data when you book a service with us including your name, address, contact
                number and email address, together with payment information in some circumstances.
                When you contact us by email or post, we may keep a record of the correspondence.
                You do not need to provide us with any personal data to view our website. All
                personal data that you provide to us must be true, complete, and accurate.
                {lineSpacing_sm}
                We do not collect any personal information that requires a special higher level of
                such as an individual’s racial or ethnic origin, political opinions, religious or
                philosophical beliefs, trade union membership, health, sex life or sexual
                orientation and genetic and biometric data.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Data we automatically collect"
            contents={
              <>
                We use Google Analytics to monitor how our website is used. Google Analytics
                collects information anonymously and generates reports detailing information such as
                the number of visits to our website, where visitors come from, how long they
                remained on the website, and which pages they visited. Google Analytics places
                several persistent cookies on your computer’s hard drive. These do not collect any
                personal data. If you do not agree to this, you can disable persistent cookies in
                your browser. This will prevent Google Analytics from logging the details of your
                visit.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Lawful processing of your data"
            contents={
              <>
                We will use your personal data in order to comply with our contractual obligation to
                supply you with the service you have booked, including to contact you with any
                information relating to the service, and to deal with any questions, comments or
                complaints you have in relation to the service.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Who do we share your data with?"
            contents={
              <>
                We may share your personal data with any service providers that we may appoint to
                perform functions on our behalf, including IT service providers, accountants,
                auditors and lawyers.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Where we hold and process your personal data"
            contents={
              <>
                All our data is stored on an encrypted server accessed only by authorised office
                staff. We will only retain your personal data for as long as necessary to fulfil the
                purposes we collected it for, including for the purposes of satisfying any legal,
                accounting, or reporting requirements.{" "}
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="Your rights"
            contents={
              <>
                You have the right to obtain from us a copy of the personal data that we hold for
                you, and to require from us to correct errors in the personal data if it is
                inaccurate or incomplete.
                {lineSpacing_sm}
                You also have the right at any time to require us to delete your personal data. If
                you further are unsure about why we are processing your personal data for the
                reasons set out above, or what we are doing with it, please ask our Data Protection
                Officer on{" "}
                <MKTypography component="span" color="text" fontWeight="bold">
                  <Email
                    email="info@spechs.ie"
                    subject="Inquiry"
                    body="Hello, I have a question about your services."
                  >
                    info@spechs.ie
                  </Email>
                </MKTypography>
                , they would be happy to provide more information.
                {lineSpacing_sm}
                You will not have to pay a fee to access your personal data. However, we may charge
                a reasonable fee if your request is clearly unfounded, repetitive or excessive.
              </>
            }
          />
          {lineSpacing_lg}
          <SubTitleContents
            title="General"
            contents={
              <>
                You are responsible for reviewing this policy so that you are aware of any changes
                to it. If you continue to use our website after the time our GDPR privacy policy
                will take effect (24.03.2022), you have accepted the changes.
              </>
            }
          />
          <NotableInfo
            text={"Note: All Policies are reviewed annually, more frequently, or as necessary."}
          />
        </Grid>
      </Grid>
    </Container>
  );
}

export default Privacy_Section1;
